var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparatorBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 24,
    viewBox: "0 0 640 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 11.5,
    width: 620.73,
    height: 1,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_470_332)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M640 11.997C639.912 11.999 639.824 12 639.736 12C639.824 12 639.912 12.001 640 12.003V11.997ZM628.365 0.627752C628.365 6.90737 633.454 11.9982 639.732 12C633.455 12.0017 628.367 17.0908 628.365 23.3689C628.363 17.0898 623.273 12 616.994 12C623.274 12 628.365 6.90846 628.365 0.627752ZM628.365 0.627752C628.365 0.539356 628.364 0.451195 628.362 0.363281H628.368C628.366 0.451195 628.365 0.539356 628.365 0.627752ZM616.991 12C616.904 12 616.817 11.9989 616.73 11.997V12.003C616.817 12.001 616.904 12 616.991 12ZM628.362 23.6367H628.368C628.366 23.5487 628.365 23.4606 628.365 23.3722C628.365 23.4606 628.364 23.5487 628.362 23.6367Z",
    fill: "#D9D9D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_470_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.27,
    height: 24,
    fill: "white",
    transform: "translate(616.73)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparatorBar);
export default __webpack_public_path__ + "static/media/separator_bar.8abbbebd0e6ff664f45adf01cac732aa.svg";
export { ForwardRef as ReactComponent };